import { useEffect } from "react";
import "./assets/scss/global.scss";
import { GlobalProvider } from "./contexts/GlobalContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { UserProvider } from "./contexts/UserContext";
import Routes from "./routes";

export default function App() {
  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      console.error("Unhandled rejection:", event.reason);
      // Optionally set a global error state
    };

    const handleGlobalError = (event) => {
      console.error("Global error:", event.error);
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleGlobalError);

    return () => {
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
      window.removeEventListener("error", handleGlobalError);
    };
  }, []);

  return (
    <GlobalProvider>
      <ThemeProvider>
        <UserProvider>
          <Routes />
        </UserProvider>
      </ThemeProvider>
    </GlobalProvider>
  );
}
